import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

import { ApplicationSettings } from "@core/models/application-settings";

@Injectable({
	providedIn: 'root'
})
export class ApplicationService {

	private applicationSubject = new Subject<ApplicationSettings>();
	private settings: ApplicationSettings;

	constructor() {

		this.settings = new ApplicationSettings('');
	}

	updateSettings(title: string, navigateBack = false, navigateToSettings = false) {

		this.settings = new ApplicationSettings(title, navigateBack, navigateToSettings);
		this.applicationSubject.next(this.settings);
	}

	public onUpdateSettings(): Observable<ApplicationSettings> {

		return this.applicationSubject.asObservable();
	}

	public getSettings(): ApplicationSettings {

		return this.settings;
	}
}